<template>
	<div>
    <div class="popup_high_right page-revisions-popup side-popup"
         :class="['level-'+level,{inactive:!step.is_active}]">
            <Loading v-show="loading"/>

	    <a @click="closePopup" v-if="!level" class="close_popup_btn">
		    <inline-svg :src="require('@/assets/img/popup_close.svg')"/>
	    </a>

            <div class="popup-container scroll">
	            <h3 class="title" >
		            <back-btn v-if="level" class="back-btn" @click="$emit('close')" />
		            Page revisions
	            </h3>

	            <div class="status-row">
<!--		            <span class="label">Type:</span>-->
<!--		            <div class="status-tags">-->
<!--			            <div class="status-tag">-->
<!--                    <inline-svg v-if="stepType.img" :src="stepType.img"/>-->
<!--	                  <span class="value">{{ stepType.title }}</span>-->
<!--			            </div>-->
<!--		            </div>-->

		            <span class="label">Last update at:</span>
		            <span class="value">{{ localDate }}</span>
		            <div class="flex"></div>
	            </div>

	            <div class="layout-column margin-t-25" style="position: relative">
		            <div class="layout-column">
			            <label class="label layout-row flex-center">Version history</label>

			            <div class="layout-column flex scroll __groups">
				            <page-revision-entry :page="page" is-current key="0l" />
				            <div v-for="(group,key) in groupedRevisions" :key="key" class="__group-entries">
					            <span class="__date-header">{{ key }}</span>
					            <page-revision-entry v-for="entry in group" :key="entry.id" :revision="entry"
					                                 :page="page" @restored="loadRevisions" />
				            </div>


			            </div>
		            </div>

	            </div>

	            <div style="min-height: 50px"></div>
            </div>
	    <div class="layout-row popup-actions">
		    <v-button label="Close" border @click="closePopup" />
	    </div>
        </div>

	</div>
</template>

<script>
import API from "@/api"
import Tooltip from "@/components/Tooltip.vue"
import Loading from "@/components/Loading.vue"
import VButton from "@/components/base/v-button";
import InfoIcon from "@/components/base/info-icon";
import InputField from "@/components/base/input-field";
import SelectField from "@/components/base/select-field";
import {getSymbol} from "@/helpers/currencies";
import numbers from "@/helpers/numbers";
import ExpandableArea from "@/components/base/expandable-area";
import CustomerEntry from "@/views/orders/customer-entry";
import OrderTimeline from "@/views/orders/order-timeline";
import OrderNotes from "@/views/orders/order-notes";
import PopupBackdrop from "@/components/base/popup-backdrop";
import BackBtn from "@/components/base/back-btn";
import QuickActionsBtn from "@/components/base/quick-actions-btn";
import CancelOrder from "@/views/orders/cancel-order";
import FulfillOrder from "@/views/orders/fulfill-order";
import OrderFulfillment from "@/views/orders/order-fulfillment";
import AddTrackingInfo from "@/views/orders/add-tracking-info";
import DeleteOrder from "@/views/orders/delete-order";
import {mapGetters} from "vuex";
import RefundOrder from "@/views/orders/refund-order";
import OrderSummary from "@/views/orders/order-summary";
import DatePicker from "@/components/base/date-picker";
import VSwitch from "@/components/base/v-switch";
import SelectButton from "@/components/base/select_button";
import DeleteDiscount from "@/views/store/delete-discount";
import stepTypes from "@/helpers/stepTypes";
import DeleteStepPopup from "@/views/funnels/funnel-plus/steps/delete-step-popup";
import PageRevisionEntry from "@/views/funnels/funnel-plus/steps/page-revision-entry";
const moment = require('moment-timezone');

export default {
	name: "page-revisions-popup",
	title: "Page revisions | Funnelish™",
	mixins: [API],
	components: {
		PageRevisionEntry,
		DeleteStepPopup,
		DeleteDiscount,
		SelectButton,
		VSwitch,
		DatePicker,
		OrderSummary,
		RefundOrder,
		DeleteOrder,
		AddTrackingInfo,
		OrderFulfillment,
		FulfillOrder,
		CancelOrder,
		QuickActionsBtn,
		BackBtn,
		PopupBackdrop,
		CustomerDetailsNew: ()=>import("@/views/customers/customer-details-new"),
		OrderNotes,
		OrderTimeline,
		CustomerEntry,
		ExpandableArea,
		SelectField,
		InputField,
		InfoIcon,
		VButton,
		Tooltip,
		Loading
	},
	props:{
		page:{},
		step:{},
		level: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			changed:false,
			saving: false,
			loading: true,
			stepTypes: stepTypes,
			revisions:[],
		}
	},
	computed:{
		...mapGetters([
			"getStepDataStore",
			"getSingleStepStore",
			"getFunnelStore"
		]),
		groupedRevisions() {
			const today = moment();
			const yesterday = moment().subtract(1, 'day');

			const groups = this.revisions.reduce((group, revision) => {
				let currDate = moment(revision.revision_created_at);
				let dayDate = '';
				if (currDate.isSame(today,'day'))
					dayDate = "Today";
				else if (currDate.isSame(yesterday,'day'))
					dayDate = "Yesterday";
				else
					dayDate = currDate.format("DD MMMM YYYY");
				group[dayDate] = group[dayDate] ?? [];
				group[dayDate].push(revision);
				return group;
			}, {});
			return groups;
		},
		stepType() {
			return this.stepTypes[this.step.type-1] || {};
		},
		isGeoFunnel() {
			return this.funnel.is_sub_funnel;
		},
		funnel() {
			return this.getFunnelStore || {}
		},
		localDate(){
			return moment(this.page.updated_at).format("DD MMMM YYYY, HH:mm:ss")
		},
		currency(){
			return getSymbol(this.getFunnelStore ?
					this.getFunnelStore.currency_code : this.$store.state.userInfo.default_currency_code)
		},
		stepPath() {
			if (!this.getFunnelStore.domain_name) return '/';
			let path = this.getFunnelStore.domain_name + '/';
			if (this.getFunnelStore.path) {
				path += this.getFunnelStore.path + '/';
			}
			return path;
		},
	},
	methods: {
		roundPrice(n) {
			return numbers.round_to_two(n)
		},
		closePopup() {
			this.$emit('close')
		},
		stripUrl(ev, field) {
			var regex = /^(?:https?:\/\/)?(?:www\.)?/i;
			var url = ev.replace(regex, '');
			this.step[field] = url.trim();
			this.changed=true;
		},
		selectType(type) {
			this.step['type'] = type;
		},
		async saveStep() {
			try {
				this.saving = true;

				this.step.url = [this.getFunnelStore.domain_name,
				                    this.getFunnelStore.path,
				                    this.step.path].filter(Boolean).join('/');

				let result = await this.api.wsteps.patch(this.funnelId, this.step);

				if (!result.error) {
					this.$store.dispatch('EDIT_STEP', result);

					this.$store.dispatch('setSingleStepStore', result);

					this.$emit('done', result)
				} else
						throw result;
				this.changed = false;
			} catch (e) {
				this.$error(e);
			} finally {
				this.saving = false;
			}
		},
		async loadRevisions() {
			try {
				this.loading = true;
				this.revisions = [];
				let res = await this.api.wsteps.getPageRevisions(this.page.funnel_id, this.page.step_id, this.page.id);
				if (!res || res.error)
					throw res;

				this.revisions = res;
			} catch (e) {
				this.$error(e);
			} finally {
				this.loading = false;
			}
		},
		async init() {
			await this.loadRevisions();
		},
	},
	created() {
		this.init();
	},
}
</script>
<style lang="scss" scoped>
.page-revisions-popup {
	padding: 0;
	.__groups {
		gap: 6px;
	}
	.__group-entries {
		gap: 6px;
		display: flex;
		flex-direction: column;
	}
	.__date-header {
		font-weight: 800;
		margin-top: 10px;
		margin-bottom: 3px;
	}
	&.archived {
		.title {
			color: $dark-grey;
		}
	}
	&.canceled {
		.title {
			text-decoration: line-through;
		}
	}
	.status-tags {
		display: flex;
		flex-direction: row;
		margin-right: 25px;
	}
	.status-tag {
		border-radius: 5px;
		background: $light-silver;
		padding: 5px 10px;
		display: flex;
		flex-direction: row;
		align-items: center;
		.value {
			margin: 0 0 0 5px;
		}
		margin-right: 3px;
	}
	&.level-1 {
		max-width: 580px;
		box-shadow: -5px 0 20px 15px rgba(0, 0, 0, 0.10);
	}
	&.level-2 {
		max-width: 560px;
		box-shadow: -5px 0 20px 15px rgba(0, 0, 0, 0.05);
	}
	.title {
		display: flex;
		flex-direction: column;
		align-items: start;
		position: relative;
		.back-btn {
			position: absolute;
			top: -30px;
		}
	}

	.popup_high_right {
		padding: 0;
	}
	.title {
		font-size: 22px;
		line-height: 150%;
		font-weight: 600;
		letter-spacing: 0.02em;
		color: #252A32;
		margin-bottom: 5px;
		background: white;
		min-height: 40px;
	}
	.popup-container {
		display: flex;
		flex-direction: column;
		flex: 1;
		padding: 35px 30px 20px;
	}
}
.status-row {
	margin-top: 10px;
	margin-bottom: 10px;
	display: flex;
	flex-direction: row;
	font-size: 13px;
	align-items: center;
	color: #26252e;
	.label {
		font-weight: bold;
		margin-right: 10px;
	}
	.value {
		display: flex;
		flex-direction: row;
		margin-right: 20px;
		margin-left: 5px;
	}

}
.popup_title {
	font-size: 20px;
}
</style>
